import { useContext, createContext } from "react";
import { baseURL } from "../lib";
import { useAuth } from "./AuthContext";
import axios from 'axios'

const FloorContext = createContext()

const FloorProvider = ({ children }) => {

    const { headers, toast, restaurantId } = useAuth();

    const getAllFloors = async (filter) => {
        try {
            const { data } = await axios.get(`${baseURL}/floor/list?restaurant_id=${restaurantId ? restaurantId : null}&filter=${filter ? filter : null}&is_web=true`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            console.log(error);
        }
    }

    const getSingleFloor = async (id) => {
        try {
            let { data } = await axios.get(`${baseURL}/floor/single-floor/${id}`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Floor', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const createFloor = async (floorDetail) => {
        try {
            const { data } = await axios.post(`${baseURL}/floor/create`, floorDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Floor', detail: data.message, life: 3000 })
                }, 500);
                return data;
            } else {
                toast.current?.show({ severity: 'error', summary: 'Floor', detail: data.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    toast.current?.show({ severity: 'error', summary: 'Floor', detail: errors[0].msg, life: 3000 })
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'Floor', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    const updateFloor = async (id, floorDetail) => {
        try {
            const { data } = await axios.put(`${baseURL}/floor/update/${id}`, floorDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Floor', detail: data.message, life: 3000 })
                }, 500);
                return data;
            } else {
                toast.current?.show({ severity: 'error', summary: 'Floor', detail: data.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    toast.current?.show({ severity: 'error', summary: 'Floor', detail: errors[0].msg, life: 3000 })
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'Floor', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    const deleteFloor = async (id) => {
        try {
            const { data } = await axios.delete(`${baseURL}/floor/delete/${id}`, { headers });
            if (data.error === false) {
                toast.current.show({ severity: 'success', summary: 'Floor', detail: data.message, life: 3000 })
            } else {
                toast.current?.show({ severity: 'error', summary: 'Floor', detail: data.message, life: 3000 })
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Floor', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    return (
        <FloorContext.Provider value={{ getAllFloors, getSingleFloor, createFloor, updateFloor, deleteFloor }}>
            {children}
        </FloorContext.Provider>
    )
}

const useFloor = () => useContext(FloorContext)

export { useFloor, FloorProvider }